AttachmentViewer = undefined
queueRequire -> AttachmentViewer = require 'views/internal/attachment-viewer'
BoardView = undefined
queueRequire -> BoardView = require 'views/board/board-view'
CardDetailView = undefined
queueRequire -> CardDetailView = require 'views/card/card-detail-view'
CreateFirstBoardView = undefined
queueRequire -> CreateFirstBoardView = require 'views/create-first-board/create-first-board-view'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
Recents = require 'lib/recents'
$ = require 'jquery'
moment = require 'moment'
trackUe = require 'debug/trackUe'
ninvoke = require 'lib/util/ninvoke'
f = require 'effing'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
TrelloPerf = require('common/debug/perf').default

# If you call someMoment.year(undefined), that's a no-op.
# If you call someMoment.year(NaN), that gives you an invalid date.
parseMaybe = (str) ->
  result = parseInt(str, 10)
  if isNaN(result)
    undefined
  else
    result

mapMaybe = (f, maybeNum) ->
  if maybeNum?
    f(maybeNum)
  else
    undefined

module.exports =
  routes: [
    # Old style URL
    ['board/*path', 'oldBoardView']
    # New style URL
    ['b/:shortLink(/*path)', 'boardView']

    # Old style URLs
    ['card/board/(:slug/):idBoard/:cardComponent', 'oldCardView']
    ['card/(:slug/):idBoard/:cardComponent', 'oldCardView']
    # New style URL
    ['c/:id(/*path)', 'cardView']
    # new user board creation
    ['create-first-board', 'createFirstBoardView']
  ]

  boardView: (shortLink, path) ->
    # :slug
    # :slug/:section
    # :slug/:section/:subsection
    # :slug/member/:username
    # :slug/calendar/:year/:month
    # :slug/calendar/:year/:month/:day
    # :slug/power-ups/enabled
    # :slug/power-ups/category/:category
    # :slug/power-up/:powerup
    path ?= ""
    [slug, section, subsection, monthOrCategory, day] = path.split('?')[0].split '/'

    settings = { idBoard: shortLink }

    if section == 'calendar'
      calendarMoment = moment().startOf('day')
      calendarMoment.year parseMaybe(subsection)
      calendarMoment.month mapMaybe(f.sub(1), parseMaybe(monthOrCategory))
      calendarMoment.date parseMaybe(day)
      if calendarMoment.isValid()
        settings.calendarDate = calendarMoment.toDate()

    if section == 'member' && subsection?
      settings.usernameBoardProfile = subsection

    if section == 'power-ups' && subsection?
      settings.directorySection = subsection
      if monthOrCategory?
        settings.directoryCategory = monthOrCategory

    if section == 'power-up' && subsection?
      settings.directoryIdPowerUp = subsection

    if section in ['calendar', 'member', 'power-up', 'power-ups']
      settings.section = section

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
    @displayBoard(settings)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
        TrelloPerf.reportStartupMetrics()
      .done()

  oldBoardView: (path) ->
    # :id
    # :slug/:id
    # :slug/:id/:section
    # :slug/:id/member/:username

    settings = {}

    parts = path.split('/')
    if parts.length == 1
      settings.idBoard = parts[0]
    else
      settings.idBoard = parts[1]

    if parts.length == 3
      settings.section = parts[2]

    else if parts.length == 4
      settings.usernameBoardProfile = parts[3]

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
    @displayBoard(settings)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
        TrelloPerf.reportStartupMetrics()
      .done()

  cardView: (shortLink, path) ->
    highlight =
      if location.hash.length > 1
        # Remove leading #
        location.hash.substr(1)
      else
        null
    replyToComment = @getQueryParamByKey('replyToComment')
    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
    @displayBoard(idCard: shortLink, highlight: highlight, replyToComment: replyToComment)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
        TrelloPerf.reportStartupMetrics()
      .done()

  oldCardView: (slug, idBoard, cardComponent) ->
    # cardComponent can be one of several things.
    #
    # It could be an id, or it could be a shortLink, which are both fine.
    # *Or* it could be an idShort, if it's a #123-style link in an old
    # notification.
    #
    # We don't want displayBoard to have to special-case this one annoying
    # scenario (it's the only case where you need to use the idBoard in order
    # to determine the idCard), so we normalize the route here to maintain
    # backwards compatibility.

    isIdShort = (str) -> /^\d+$/.test(str)

    idCardPromise = if isIdShort(cardComponent)
      ModelLoader.for 'top-level', 'loadCardId', idBoard, cardComponent
      .catch ApiError, -> null
    else
      Promise.resolve(cardComponent)

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
    idCardPromise.then (idCard) =>
      @displayBoard({ idBoard, idCard })
        .tap ->
          TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
          TrelloPerf.reportStartupMetrics()
      .done()

  showCardDetail: (card, { highlight, runMethod, isNavigating, replyToComment, clearToolTip, method } = {}) ->
    if !card?
      return

    if !@onBoardView(card.getBoard()?.id) ||
       (card.modelCache != @getCurrentModelCache())
      @navigate @getCardUrl(card, highlight, replyToComment), { trigger: true }
      return

    # track entrances from both card front and external sources
    method ?= ''
    trackUe('card details', 'opens', 'card details view', '', '', method, {
      loggedIn: Auth.isLoggedIn(),
      visibility: card.getBoard().getPref('permissionLevel'),
      cardId: card.id,
      boardId: card.getBoard().id
    })

    if clearToolTip
      $('.js-guided-tour-tooltip:not(.js-tool-tip-card-desc)').addClass('hide')

    cardDetailView = new CardDetailView(modelCache: @getCurrentModelCache(), model: card)

    # Figure out if we're showing the calendar before we open the dialog;
    # it's possible that the card will get moved to another board
    # while the dialog is open
    board = card.getBoard()
    showingCalendar = @showingCalendar(card.getBoard() && @applicationView.existingSubviewOrUndefined(BoardView, card.getBoard()))

    Dialog.show
      view: cardDetailView
      hide: (isNavigating) =>
        $('.js-tool-tip-card-back').toggleClass('hide', !clearToolTip)
        AttachmentViewer.clear()
        if !isNavigating
          # This is bad. Here we're guessing the right URL for return.
          # It's necessary because the user can mess around with the back and
          # forward buttons to get this dialog to pop by URL.
          @setBoardLocation(
            board.id,
            'calendar' if showingCalendar
          )

          @title board.get('name')

      isNavigating: isNavigating

    @waitForId card, =>
      @navigate @getCardUrl(card, highlight, replyToComment),
        replace: @onCardView()
        trigger: false
      Recents.add('card', card.id)

    if runMethod?
      cardDetailView[runMethod]()

    if highlight?
      cardDetailView.highlight(highlight, true)

    if replyToComment?
      cardDetailView.replyToComment(replyToComment)

    return

  createFirstBoardView: ->
    Promise.using @getSpinner(), =>
      return ModelLoader.await('boardsData').then =>
        me = Auth.me()
        if !me.isLoggedIn()
          return window.location = '/login'

        memberHasBoards = me.boardList.length > 1 ||
          (me.boardList.length == 1 && !me.boardList.models[0].isWelcomeBoard())
        if memberHasBoards || me.isDismissed('create-first-board')
          return @navigate '/', { trigger: true }

        @clearPreviousView()
        @setViewType('create-first-board')
        @title('Create Your Board')
        view = @topLevelView(CreateFirstBoardView, me)
        $('#classic-body').addClass('body-hide-header')
        $('#content').html(view.render().el)
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/board-routes.coffee